import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContentContext = createContext({});

export const SiteContentProvider = ({ children }) => {
    const [content, setContent] = useState({});
    const [loaded, setLoaded] = useState(false);

    const refresh = async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data || {});
        } catch {
            setContent({});
        } finally {
            setLoaded(true);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    const t = (key, fallback = "") => {
        const v = content[key];
        return v != null && v !== "" ? v : fallback;
    };

    return (
        <SiteContentContext.Provider value={{ content, t, loaded, refresh }}>
            {children}
        </SiteContentContext.Provider>
    );
};

export const useSiteContent = () => useContext(SiteContentContext);
